import { render, staticRenderFns } from "./Bulb.vue?vue&type=template&id=ff85ae34&scoped=true"
import script from "./Bulb.vue?vue&type=script&lang=ts"
export * from "./Bulb.vue?vue&type=script&lang=ts"
import style0 from "./Bulb.vue?vue&type=style&index=0&id=ff85ae34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff85ae34",
  null
  
)

export default component.exports